import React from "react";

/** Field -> CSV column mapping editor with a sample value per field. */
export default function CsvMappingTable({ fields, headers, mapping, sample, onChange, testId }) {
  return (
    <table className="perm-table map-table" data-testid={testId}>
      <thead>
        <tr>
          <th>Field</th>
          <th>CSV column</th>
          <th>Sample</th>
        </tr>
      </thead>
      <tbody>
        {fields.map((f) => (
          <tr key={f.id}>
            <td>
              {f.label} {f.required && <span className="mini-chip warn">required</span>}
            </td>
            <td>
              <select className="ws-native-select" value={mapping[f.id] || ""} onChange={(e) => onChange({ ...mapping, [f.id]: e.target.value })} data-testid={`${testId}-${f.id}`}>
                <option value="">— not in file —</option>
                {headers.map((h) => (
                  <option key={h} value={h}>
                    {h}
                  </option>
                ))}
              </select>
            </td>
            <td className="muted small mono trunc">{mapping[f.id] && sample ? String(sample[mapping[f.id]] ?? "").slice(0, 60) : ""}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
